export const eligibleToPurchase = (customer, vehicle) => {
  const homeAddress = customer?.homeAddress;
  const mileage = vehicle?.mileage;
  const fuelDescription = vehicle?.fuelDescription
    ? vehicle?.fuelDescription.toLowerCase()
    : 'electric';

  let isEligibleToPurchase = true;

  if (homeAddress?.state === 'CA' && fuelDescription !== 'electric') {
    isEligibleToPurchase = mileage > 7500;
  }

  return isEligibleToPurchase;
};

export const getVehicleImageUrl = stockNumber =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/${stockNumber}-edc-02-search.jpg`;

export const getCloseUpVehicleImageUrl = stockNumber =>
  `${process.env.VEHICLE_IMAGE_CDN_URL}/${stockNumber}/post-large/normalized/zoomcrop/${stockNumber}-edc-02.jpg`;

export const setDashboardModuleStatus = (newStatus = {}) => {
  const statusCssClass = newStatus?.actionIsRequired
    ? 'actionRequired'
    : newStatus?.isComplete
    ? 'complete'
    : newStatus?.isDisabled
    ? 'disabled'
    : 'pending';

  return {
    actionRequiredName: null,
    actionIsRequired: false,
    isComplete: false,
    isDisabled: false,
    statusCssClass,
    ...newStatus
  };
};
